import React, { useState } from "react";
import { Link } from "react-router-dom";
const ProductSidenav = () => {
  const [toggle, setToggle] = useState(false);

  const handleProduct = () => {
    setToggle((prev) => !prev);
  };
  return (
    <div className="SideNav" style={{ height: "100vh", background: "#eee" }}>
      <ul>
        <li>
          <Link to="/admin/home">Home</Link>{" "}
        </li>
        <li onClick={handleProduct}>
          <Link>Product</Link>
        </li>
        {toggle && (
          <li>
            <ul>
              <li>
                <Link to="/admin/addproduct">Add Product</Link>
              </li>
            </ul>
          </li>
        )}

        <li>
          <Link href="./"> Orders</Link>
        </li>
        <li>
          <Link href="./"> logout</Link>
        </li>
      </ul>
    </div>
  );
};

export default ProductSidenav;
